"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.ResetPasswordFieldNames.username]: '',
};
const ResetPasswordForm = ({ pending }) => (React.createElement(React.Fragment, null,
    React.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.ResetPasswordSchema, onSubmitPayload: api_payloads_1.resetPasswordPayload, formKey: services_1.endpoints.getResetPassword },
        React.createElement("div", { className: styles_scss_1.default.resetPasswordInputs },
            React.createElement("div", { className: styles_scss_1.default.resetPasswordInputRow },
                React.createElement(fields_1.TextInputField, { type: "text", name: field_names_1.ResetPasswordFieldNames.username, label: constants_1.default.general.email, placeholder: constants_1.default.login.enterEmail, accessory: {
                        default: constants_1.Images.mail,
                        active: constants_1.Images.mailActive,
                        error: constants_1.Images.mailError,
                    } }))),
        React.createElement(form_error_1.default, { formKey: services_1.endpoints.getResetPassword }),
        React.createElement("div", { className: styles_scss_1.default.buttons },
            React.createElement(buttons_1.SubmitButton, { disableOnErrors: true, disabled: pending, ariaLabel: constants_1.default.resetPassword.sendMeInstructions, title: constants_1.default.resetPassword.sendMeInstructions, className: styles_scss_1.default.submitButton })))));
exports.default = ResetPasswordForm;
